// Use values of EventMap to enforce specific Event types below.
interface EventMap {
  'appConfigFetched': CustomEvent<[string, any, Response]>;
  'authDataSet': Event;
  'clearPendingNotificationsCount': Event;
  'configFetched': CustomEvent<[string, any, Response]>;
  'DialogContainer.startClose': CustomEvent<{dialogId: string}>;
  'DialogContainer.finishClose': Event;
  'favoriteDataSet': Event;
  'finish-progress-bar': Event;
  'googleAuthLoadChange': Event;
  'list-items-exhausted': Event;
  'manual-hashchange': Event;
  'refreshNotifications': Event;
  'start-progress-bar': Event;
  'uploads-processed': Event;
}

type EventNames = keyof EventMap;
type EventHandler<T extends EventNames> = (evt: EventMap[T]) => void;

const target = new EventTarget();

export default {
    target,
    on: <T extends EventNames>(eventName: T, handler: EventHandler<T>) => {
        target.addEventListener(eventName, handler);
    },
    off: <T extends EventNames>(eventName: T, handler: EventHandler<T>) => {
        target.removeEventListener(eventName, handler);
    },
    emit: <T extends EventNames>(eventName: T, detail?: any) => {
        const event = detail ?
            new CustomEvent(eventName, {detail}) :
            new Event(eventName);
        target.dispatchEvent(event);
    },
};
